<template>
  <div class="lego-pagination" v-if="pagination.totalItems > 0">
    <div
      class="lego-pagination__navi"
      :class="[
        { 'lego-pagination__icon--disable': isLeftEnd },
        { 'lego-pagination__icon--hide': range.length <= 1 }
      ]"
      @click="onClickLeft"
    >
      <lego-icon
        class="lego-pagination__left-icon"
        icon-type="df"
        icon="pagination_left_24"
        :size="24"
      />
      {{ $t('button.previous') }}
    </div>
    <div
      class="lego-pagination__navi"
      :class="[
        { 'lego-pagination__icon--disable': isRightEnd },
        { 'lego-pagination__icon--hide': range.length <= 1 }
      ]"
      @click="onClickRight"
    >
      {{ $t('button.next') }}
      <lego-icon
        class="lego-pagination__right-icon"
        icon-type="df"
        icon="pagination_right_24"
        :size="24"
      />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pagePart: 10
    };
  },
  emits: ['move'],
  props: {
    showGotoButton: { type: Boolean, default: false },
    props: {
    // $ver: v0.1.0
    // 페이징 처리를 위한 속성 객체입니다. rowsPerPage, currentPage, totalPages, totalItem 속성을 가지고 있습니다.
    // #Property object for paging processing. It has rowsPerPage, currentPage, totalPages and totalItem properties.
    // $default: rowsPerPage - 10, currentPage - 1, totalPages - 0, totalItem - 0
    pagination: {
      type: Object,
      required: true,
      default: () => {
        return {
          rowsPerPage: 10,
          currentPage: 1,
          totalPages: 0,
          totalItems: 0,
        };
      },
    },
    // $ver: v0.1.0
    // Simple 유형 여부입니다.
    // #Whether it is a Simple type.
    // $default: false
    simple: { type: Boolean, default: false },

    // $ver: v0.1.2
    // 페이지 입력 및 바로 이동을 위한 버튼 텍스트 입니다.
    // #Button text for page input and direct navigation.
    // $default: 'GO'
    moveMessage: { type: String },
  },
  },
  computed: {},
  methods: {}
};
</script>
<style scoped lang="scss">
.lego-pagination {
  @include font($size: $lego-pagination__font-size);
  gap: 24px;
  .lego-pagination__navi{
    width: auto;
    margin: 0;
    color: #2E3138;
    .lego-icon{
      color: #2E3138;
    }
  }

  :deep .lego-pagination__left-icon,
  :deep .lego-pagination__right-icon {
    transform: rotate(0deg);
  }

  .lego-pagination__icon {
    &--disable {
      :deep .lego-icon {
        color: $lego-pagination__navi__icon-color--disabled;
      }
    }
    &--hide {
      display: none;
    }
  }

  .lego-pagination__navi {
    &:hover {
      background: none;
      color: #000000;
      .lego-icon {
        color: #000000;
      }
    }
  }
  .lego-pagination__number {
    &:active {
      color: $color--primary;
      font-weight: $lego__font-weight--bold;
    }
  }
}
</style>
